var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 773,
    height: 462,
    viewBox: "0 0 773 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_346_180)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M748.939 457.188H601.677C591.09 457.188 582.427 448.525 582.427 437.938V346.5C582.427 323.4 564.139 305.113 541.039 305.113C517.939 305.113 499.652 323.4 499.652 346.5V437.938C499.652 448.525 490.989 457.188 480.402 457.188H335.064C324.477 457.188 315.814 448.525 315.814 437.938V191.538C315.814 174.213 324.477 157.85 337.952 148.225L531.414 8.6626C538.152 3.8501 546.814 3.8501 553.552 8.6626L747.014 148.225C760.489 157.85 769.152 174.213 769.152 191.538V438.9C768.189 448.525 759.527 457.188 748.939 457.188ZM620.927 419.65H730.652V191.538C730.652 186.725 727.764 181.913 723.914 179.025L542.002 47.1626L360.089 178.063C356.239 180.95 353.352 185.763 353.352 190.575V418.688H463.077V346.5C463.077 303.188 498.689 267.575 542.002 267.575C585.314 267.575 620.927 303.188 620.927 346.5V419.65Z",
    fill: "#0B2640"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 254.5C-3.33449e-07 246.872 6.19339 240.688 13.8333 240.688H201.77L128.552 167.579C123.149 162.185 123.149 153.44 128.552 148.046C133.954 142.651 142.713 142.651 148.115 148.046L244.948 244.733C244.956 244.741 244.963 244.748 244.971 244.756C246.285 246.074 247.277 247.59 247.949 249.209C248.626 250.838 249 252.626 249 254.5C249 258.303 247.461 261.747 244.971 264.244C244.963 264.252 244.956 264.259 244.948 264.267L148.115 360.954C142.713 366.349 133.954 366.349 128.552 360.954C123.149 355.56 123.149 346.815 128.552 341.421L201.77 268.312H13.8333C6.1934 268.313 3.33449e-07 262.128 0 254.5Z",
    fill: "#0B2640"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_346_180"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 773,
    height: 462,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrder);
export default __webpack_public_path__ + "static/media/order.5923d0efb25f88152bebf20fb75e6040.svg";
export { ForwardRef as ReactComponent };